import Component from '@bythepixel/component-loader';

export default class HeroVideo extends Component {
  static selector = '[data-comp-hero-video]';
}

// YouTube API will call this function when it's ready
window.onYouTubeIframeAPIReady = () => {
  const heroes = document.querySelectorAll(HeroVideo.selector);
  if (heroes.length === 0) return;
  heroes.forEach(hero => {
    const youtubeVideo = hero.querySelector('[data-youtube-video-id]');

    if (youtubeVideo) {
      const { youtubeVideoId } = youtubeVideo.dataset;

      window.player = new window.YT.Player(youtubeVideo.id, {
        width: '100%',
        videoId: youtubeVideoId,
        playerVars: {
          autoplay: 1,
          controls: 0,
          loop: 1,
          playlist: youtubeVideoId,
          playsinline: 1,
        },
        events: {
          onReady: onPlayerReady,
        },
      });
    }
  });
};

function onPlayerReady(event) {
  event.target.mute();
  event.target.playVideo();
}
